export default class Map {
   
    constructor(_containerId, location) {
        this.containerId = _containerId;
        this.location = location;
    }

    Draw() {
        const longitud = this.getLongitud();
        const latitud = this.getLatitud();

        if (!longitud || !latitud) return;


        var mymap = L.map(this.containerId).setView([latitud, longitud], 15);
        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
                '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
                'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            tileSize: 512,
            maxZoom: 18,
            zoomOffset: -1,
            id: 'mapbox/streets-v11',
            accessToken: 'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw'
        }).addTo(mymap);

        L.marker([latitud, longitud]).addTo(mymap);
    }

    getLongitud() {
        const mapa = document.getElementById(this.containerId);
        if (!mapa) return;
        let { longitud } = mapa.dataset;
        if (this.location && this.location.long) {
            longitud = this.location.long;
        }
        return longitud;
    }

    getLatitud() {
        const mapa = document.getElementById(this.containerId);
        if (!mapa) return;
        let { latitud } = mapa.dataset;
        if (this.location && this.location.lat) {
            latitud = this.location.lat;
        }
        return latitud;
    }
}





// WEBPACK FOOTER //
// ./Statics/scripts/Modules/Map.js